<div class="container">
        <h1 class="fs-2 fw-light mt-4">Laws</h1>
        @if (associatedPropertyIds.length > 0) {
            <p class="text-muted">Showing laws for associated properties: {{ associatedPropertyIds.join(', ') }}</p>
        }

        @if (!loading && associatedPropertyIds.length == 0) {
            <div class="alert alert-warning mt-4">No associated properties found for your account.</div>
        }

        @if (associatedPropertyIds.length > 0) {
            <div class="form-group has-search my-3">
                <input type="text" name="searchLaw" [(ngModel)]="searchLaw" class="form-control" placeholder="Search laws by title or description" />
            </div>

            @if (loading) {
                <div class="my-4">
                    <span class="spinner-border spinner-border-sm mr-1"></span>
                    <span>Loading laws...</span>
                </div>
            }

            @if (!loading && laws.length == 0) {
                <div class="alert alert-info">No laws are currently available for your associated properties.</div>
            }

            @if (!loading && laws.length > 0) {
                <ul class="list-group list-group-flush my-3">
                    @for (law of laws; track law.id) {
                        @if ((law.title + ' ' + law.description).toLowerCase().includes(searchLaw.toLowerCase())) {
                            <li class="list-group-item">
                                <h5 class="mb-1">{{ law.title }}</h5>
                                <p class="mb-1 text-muted">{{ law.description }}</p>
                                <small class="text-secondary">Property ID: {{ law.propertyId }}</small>
                            </li>
                        }
                    }
                </ul>
            }
        }

        <div class="mt-4 d-flex justify-content-between align-items-center">
            <button (click)="goBack()" class="btn btn-primary d-print-none"><fa-icon [icon]="faCircleArrowLeft"></fa-icon> Back</button>
            <button (click)="goHome()" class="btn btn-info d-print-none"><fa-icon [icon]="faHomeAlt"></fa-icon> Home</button>
        </div>
</div>
